import { createFileRoute, redirect, isRedirect } from '@tanstack/react-router'
import { postEnginePlayNew } from '@/types/origin-point-engine'
import { logger } from '@/lib/logger'
import { showErrorData } from '@/lib/toast'

/**
 * 自动创建新会话的路由
 *
 * 用途：用于分享链接场景，访问 /chats/new/{engineId} 时自动创建新会话并跳转
 * 流程：
 * 1. beforeLoad 中调用 postEnginePlayNew API
 * 2. 获取返回的 sessionId
 * 3. 重定向到 /chats/{sessionId}
 */
export const Route = createFileRoute('/_authenticated/chats/new/$engineId')({
  beforeLoad: async ({ params }) => {
    const { engineId } = params

    try {
      logger.info('[AutoStartSession] 正在为引擎创建新会话', { engineId })

      // 调用 API 创建新会话
      const response = await postEnginePlayNew({
        engineId,
      })

      const sessionId = response?.data?.session?.id

      if (!sessionId) {
        logger.error('[AutoStartSession] 创建会话成功但未获取到 sessionId', {
          response,
        })
        showErrorData('创建会话失败：未获取到会话ID')
        throw redirect({ to: '/' })
      }

      logger.info('[AutoStartSession] 会话创建成功，跳转到聊天页面', {
        sessionId,
      })

      // 重定向到新创建的会话页面
      throw redirect({
        to: '/chats/$sessionId',
        params: { sessionId },
      })
    } catch (error) {
      // 使用官方推荐的方法判断是否为重定向
      if (isRedirect(error)) {
        throw error
      }

      // 处理其他错误
      logger.error('[AutoStartSession] 创建会话失败', error)
      showErrorData('创建会话失败', error)

      // 失败时重定向到首页
      throw redirect({ to: '/' })
    }
  },
  // 组件不会被渲染（因为 beforeLoad 总是会 redirect）
  // 但为了避免 TypeScript 错误，提供一个空组件
  component: () => null,
})
